import * as types from '../constants/ActionTypes';
import { b64toBlob } from '../helpers/TextUtils';
import { isImage } from '../helpers/AttachmentUtils';

import { assoc, dissoc, dissocPath, merge, omit } from 'ramda';
import { isEmpty } from 'lodash';

const attachments = (state = {}, action) => {
  switch (action.type) {
    case types.GET_ATTACHMENT_SUCCESS: {
      const { attachment } = action.payload;
      const blob = b64toBlob(attachment.data, attachment.mediaType);
      const url = URL.createObjectURL(blob);
      const finalAttachment = omit(['data'], assoc('displayUrl', url, assoc('downloadUrl', url, attachment)));

      return { ...state, [attachment.id]: finalAttachment };
    }
    case types.GET_MESSAGES_SUCCESS:
    case types.MESSAGE_RECEIVED_SUCCESS:
      return merge(state, action.payload.attachments);
    case types.REVOKE_ATTACHMENT_URL: {
      const attachmentId = action.payload;
      const downloadUrl = state[attachmentId].downloadUrl;
      URL.revokeObjectURL(downloadUrl);
      // Need to have paths as a string to work properly
      return dissocPath([attachmentId.toString(), 'downloadUrl'], state);
    }
    case types.ADD_LOCAL_ATTACHMENT: {
      const { attachment } = action.payload;

      return {
        ...state,
        [attachment.id]: {
          ...attachment,
          isLocal: true,
        },
      };
    }
    case types.UPDATE_LOCAL_ATTACHMENT: {
      const { id, _id } = action.payload;

      return {
        ...state,
        [id]: {
          ...state[id],
          _id,
        },
      };
    }
    case types.DOWNLOAD_ATTACHMENT: {
      const { attachmentId } = action.payload;

      const attachment = state[attachmentId] || {};

      return {
        ...state,
        [attachmentId]: {
          ...attachment,
          isDownloading: true,
        },
      };
    }
    case types.DOWNLOAD_ATTACHMENT_SUCCESS: {
      const { blob, attachmentId } = action.payload;
      const url = URL.createObjectURL(blob);
      const attachment = state[attachmentId];

      if (isImage(attachment)) {
        return {
          ...state,
          [attachmentId]: {
            ...attachment,
            displayUrl: url,
            downloadUrl: url,
            isDownloading: false,
          },
        };
      }

      return {
        ...state,
        [attachmentId]: {
          ...attachment,
          downloadUrl: url,
          isDownloading: false,
        },
      };
    }
    case types.DOWNLOAD_ATTACHMENT_FAIL: {
      const { attachmentId } = action.payload;

      const attachment = state[attachmentId] || {};

      return {
        ...state,
        [attachmentId]: {
          ...attachment,
          hasError: true,
          isDownloading: false,
        },
      };
    }
    case types.DOWNLOAD_VIDEO_IMAGE_ATTACHMENT_SUCCESS: {
      const { blob, attachmentId } = action.payload;
      const url = URL.createObjectURL(blob);
      const attachment = state[attachmentId];

      return {
        ...state,
        [attachmentId]: {
          ...attachment,
          displayUrl: url,
        },
      };
    }
    case types.REMOVE_MESSAGE: {
      const { attachments } = action.payload.message;

      if (isEmpty(attachments)) {
        return state;
      }

      return dissoc(attachments, state);
    }
    case types.REMOVE_ATTACHMENTS: {
      const { attachmentIds } = action.payload;
      return omit(attachmentIds, state);
    }
    default:
      return state;
  }
};

export default attachments;
